<!-- 数据统计 -->
<template>
  <Layout>
    <div class="row">
      <div
        style="
          width: 100%;
          background-color: white;
          padding: 10px 0 10px 10px;
          box-sizing: border-box;
        "
        class="flex-depart-center"
      >
        <div class="tabs-box">
          <div class="tabs-item" @click="changTab(1)">
            <span :class="{ 'act-tabs-style': tabNum == 1 }">表格视图</span>
          </div>
          <div class="tabs-item" @click="changTab(2)">
            <span :class="{ 'act-tabs-style': tabNum == 2 }">统计分析</span>
          </div>
        </div>
        <div class="btns-box flex-depart-center">
          <el-button class="custom-btn" round @click="openTimePop"
            >筛选日期</el-button
          >
          <el-button
            class="custom-btn-primary"
            type="primary"
            round
            v-if="tabNum == 1"
            @click="toPageDaoChu"
            ><i class="el-icon-upload"></i> 导出数据</el-button
          >
          <el-button
            class="custom-btn-primary"
            type="primary"
            round
            v-if="tabNum == 2"
            @click="daoChuData"
          >
            <i class="el-icon-upload"></i> 导出分析数据
          </el-button>
        </div>
      </div>
      <div
        style="width: 100%; background-color: white"
        class="b-marT-10"
        v-if="tabNum == 1"
      >
        <div class="table-responsive">
          <table class="table table-hover mb-0 table-width">
            <thead>
              <tr>
                <th
                  v-for="(item, idx) in theadList"
                  :key="item.key"
                  :class="getThClass(item, idx)"
                >
                  <span class="no-wrap">{{ item.title }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in tbodyList" :key="index">
                <!-- 序号列（固定第一列） -->
                <td class="sticky-col-first">{{ index + 1 }}</td>
                <!-- 动态字段列 -->
                <td
                  v-for="(head, i) in theadList.slice(1, -1)"
                  :key="i"
                  :class="getTdClass(i)"
                >
                  <!-- 图片 -->
                  <div
                    v-if="head.type === '5'"
                    class="no-wrap colorBlue"
                    @click="seeBigImg(row[head.key], 1, row, head, index)"
                  >
                    {{
                      (row[head.key] && row[head.key].length) || 0
                    }}张，[查看图片]
                  </div>
                  <!-- 拍照上传 -->
                  <div
                    v-else-if="head.type === '35'"
                    class="no-wrap colorBlue"
                    @click="seeBigImg(row[head.key], 1, row, head, index)"
                  >
                    {{
                      (row[head.key] && row[head.key].length) || 0
                    }}张，[查看图片]
                  </div>
                  <!-- 文件 -->
                  <div v-else-if="head.type === '32'">
                    <div
                      v-if="!row[head.key] || row[head.key].length === 0"
                      class="no-wrap"
                    >
                      -
                    </div>
                    <div
                      v-else
                      v-for="(fItem, fileIndex) in row[head.key]"
                      :key="fileIndex"
                      class="no-wrap colorBlue position-relative"
                      @click="seeFile(fItem, fileIndex)"
                    >
                      {{ fItem.name }}
                      <a :href="imageUrl + fItem.fileUrl" download=""></a>
                    </div>
                  </div>
                  <!-- 视频 -->
                  <div
                    v-else-if="head.type === '6'"
                    class="colorBlue"
                    @click="seeVideo(row[head.key], row)"
                  >
                    <video
                      :key="'video-' + index + '-' + head.key"
                      width="150"
                      height="100"
                      controls
                      v-if="row[head.key] && !row[head.key].includes('|')"
                    >
                      <source :src="row[head.key]" type="video/mp4" />
                    </video>
                    <span v-else>{{ "-" }}</span>
                  </div>
                  <!-- 音频 -->
                  <div
                    v-else-if="head.type === '7'"
                    class="colorBlue"
                    @click="onPlay(row[head.key])"
                  >
                    <audio controls width="100" height="100">
                      <source :src="row[head.key]?.url" type="audio/ogg" />
                    </audio>
                  </div>
                  <!-- 签名 -->
                  <div
                    v-else-if="head.type === '29'"
                    class="no-wrap colorBlue"
                    @click="seeSignature(row[head.key], row)"
                  >
                    [查看签名]
                  </div>
                  <!-- 所在位置 -->
                  <div v-else-if="head.type === '12'">
                    {{ (row[head.key] && row[head.key].address) || "-" }}
                  </div>
                  <!-- 文件签字-->
                  <div
                    v-else-if="head.type === '36'"
                    class="no-wrap colorBlue"
                    @click="seeSignFileImg(row[head.key], 1, row)"
                  >
                    {{
                      (row[head.key] && row[head.key].length) || 0
                    }}张，[查看图片]
                  </div>
                  <!-- 其他 -->
                  <div
                    v-else
                    class="no-wrap"
                    @click="seeData(row[head.key], index)"
                  >
                    {{ row[head.key] || "-" }}
                  </div>
                </td>
                <!-- 更多列（固定最后一列） -->
                <td class="sticky-col-last">
                  <div class="more-btn" @click="lookUserDetail(row, index)">
                    查看更多
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- 分页 -->
          <div
            style="text-align: center; margin-top: 20px"
            v-if="!nodataShow && tbodyList.length > 0"
          >
            <el-pagination
              background
              layout="sizes,prev, pager, next,total"
              :page-sizes="[10, 20, 50, 100]"
              :total="totalCount"
              :current-page="currentPage"
              :page-size="pageSize"
              @size-change="handleSizeChange"
              @current-change="handlePageChange"
            >
            </el-pagination>
          </div>
          <!-- 暂无数据 -->
          <div class="nodata-box" v-if="nodataShow == true">
            <img
              src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/tjfx-nodata.svg"
              alt=""
            />
            <span>暂无数据</span>
          </div>
        </div>
      </div>
      <div style="width: 100%" class="b-marT-10" v-if="tabNum == 2">
        <div class="s-analysis">
          <div class="tips">
            统计分析支持的字段有：单选、多选，并剔除了已经取消的数据。
          </div>
          <div
            v-for="(item, index) in analysisData"
            :key="item.type + index"
            class="analysis-item"
          >
            <!-- 左侧表格 -->
            <div class="analysis-table">
              <div class="t-title">
                {{ item.question.split("/")[0] }}[{{ item.type }}]
              </div>
              <table class="table table-hover mb-0 table-width">
                <!-- 表头行 -->
                <thead>
                  <tr style="background-color: #dcdcdc">
                    <th>选项</th>
                    <th>小计</th>
                    <th>比例</th>
                    <th>谁选了</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- 表格数据行 -->
                  <tr
                    v-for="(option, optIndex) in item.options"
                    :key="optIndex"
                  >
                    <td align="left">{{ option.label }}</td>
                    <td align="left">{{ option.count }}</td>
                    <td align="left">{{ option.percentage }}</td>
                    <td align="left">
                      <span class="colorBlue" @click="seeWhoSelected(item)"
                        >查看</span
                      >
                    </td>
                  </tr>
                  <!-- 合计行 -->
                  <tr>
                    <td align="left">合计</td>
                    <td align="left">{{ item.total.count }}</td>
                    <td align="left">{{ item.total.percentage }}</td>
                    <td align="left">
                      <span class="colorBlue" @click="seeWhoSelected(item)"
                        >查看</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- 右侧图表 -->
            <div class="analysis-chart">
              <ChartItem :optionObj="item" />
            </div>
          </div>
          <div class="nodata-box" v-if="nodataShow == true">
            <img
              src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/tjfx-nodata.svg"
            />
            <span>暂无数据</span>
          </div>
        </div>
      </div>

      <el-dialog
        title="筛选导出范围"
        :visible.sync="filterTimesBoxShow"
        width="450px"
        :before-close="cancelFTSet"
        :show-close="false"
      >
        <template slot="title">
          <CustomDialogHeader
            title="筛选导出范围"
            @close="filterTimesBoxShow = false"
          />
        </template>
        <div class="s-times-box">
          <div
            class="times-item"
            v-for="(item, index) in timeFilterArr"
            :key="item.type"
            :class="{
              'times-item-active':
                index == filterDateArr[filterDateType].currentDateIndex,
            }"
            @click="currentSelect(item, index)"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="sort-box">
          <div class="sort-title">自定义日期</div>
          <div class="timeRangeOutBox flex-depart-center">
            <el-date-picker
              v-model="filterDateArr[filterDateType].startQueryTime"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
            <span style="padding-left: 10px; padding-right: 10px">-</span>
            <el-date-picker
              v-model="filterDateArr[filterDateType].endQueryTime"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelFTSet">取 消</el-button>
          <el-button type="primary" @click="submitFn">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog
        :title="dialogUserName ? dialogUserName : '查看'"
        :visible.sync="photoShow"
        width="900px"
        @close="closeSwiper"
        :show-close="false"
      >
        <template slot="title">
          <CustomDialogHeader
            :title="dialogUserName ? dialogUserName : '查看'"
            @close="closeSwiper"
          />
        </template>
        <div>
          <el-carousel indicator-position="outside" height="550px">
            <el-carousel-item v-for="item in photoList" :key="item">
              <div style="text-align: center">
                <img class="swiper-img" :src="item" alt="" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-dialog>

      <!-- 选项分析抽屉 -->
      <el-drawer
        title="选项分析"
        :visible.sync="optionAnalysisDrawerShow"
        direction="rtl"
        size="600px"
        :before-close="handleOptionDrawerClose"
      >
        <template slot="title">
          <div style="text-align: center; font-weight: bold; font-size: 18px">
            选项分析
          </div>
        </template>
        <div class="option-analysis-content">
          <div class="analysis-question-title">
            {{ optionAnalysisQuestion }}
          </div>
          <div
            class="analysis-option-item"
            v-for="(item, index) in optionAnalysisList"
            :key="index"
          >
            <div class="analysis-option-header">
              <div class="analysis-option-header-left">
                {{ item.key }}({{ item.value.length }}人)
              </div>
              <div
                class="analysis-option-header-right"
                @click="Array.isArray(item.value) && copyNames(item.value)"
              >
                复制名单
              </div>
            </div>
            <div class="analysis-option-body" v-if="Array.isArray(item.value)">
              <span
                class="analysis-option-name"
                v-for="(name, idx) in item.value"
                :key="idx"
                @click="onViewMore(name)"
              >
                {{ getName(name)
                }}<span v-if="idx < item.value.length - 1">，</span>
              </span>
            </div>
          </div>
        </div>
      </el-drawer>
      <el-drawer
        :title="dialogUserName + ' - 参与信息'"
        :visible.sync="userDetailShow"
        width="900px"
        @close="closeSwiper"
        class="user-detail-drawer"
      >
        <ActivityPlayerItem
          v-for="(item, index) in userDetailList"
          :key="item.id != null ? item.id : index"
          :item="item"
          :activityId="activityId + ''"
          :isOtherPeople="1"
          showContent
        >
        </ActivityPlayerItem>
      </el-drawer>
      <el-drawer
        :title="dialogUserName + ' - 参与信息'"
        :visible.sync="viewMoreShow"
        width="900px"
        @close="closeSwiper"
        class="user-detail-drawer"
      >
        <ActivityPlayerItem
          v-for="(item, index) in viewMoreList"
          :key="item.id != null ? item.id : index"
          :item="item"
          :activityId="activityId + ''"
          :isOtherPeople="1"
          showContent
        >
        </ActivityPlayerItem>
      </el-drawer>
    </div>
  </Layout>
</template>
<script>
import CustomDialogHeader from "@/components/CustomDialogHeader.vue";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import ChartItem from "./ChartItem.vue";

import { imageUrl } from "@/utils/config/commonUrl.js";
// import ParticipationInfoCard from "../orderManagementDetail/ParticipationInfoCard/index.vue";
import ActivityPlayerItem from "@/components/ActivityPlayerItem/index.vue";

import {
  tableAttempting,
  listAnalysis,
  listAnalysisExport,
  ListOfPersonnelOptions,
  activityDetail,
  getSignListMore,
  getNewVideoPathUrl,
} from "@/utils/api/activity";

var dayjs = require("dayjs");
const d = new Date();
const year = d.getFullYear();
let month = d.getMonth() + 1;
month = month < 10 ? `0${month}` : month;
const date = d.getDate();

export default {
  page() {
    return {
      title: `${this.actName} - 数据统计`,
      meta: [{ name: "description", content: appConfig.description }],
    };
  },
  components: { Layout, CustomDialogHeader, ChartItem, ActivityPlayerItem },
  data() {
    return {
      selectedItem: {},
      userDetailShow: false,
      viewMoreShow: false,
      userDetailList: [],
      viewMoreList: [],
      viewMoreActivityId: "",
      value1: "",
      imageUrl: imageUrl,
      // 数据统计
      value: "7878",
      theadList: [],
      tbodyList: [],
      rawData: [],
      headers: [],
      tabNum: 1,
      currentDateIndex: 0,
      filterDateType: 0,
      filterDateArr: [
        {
          startQueryTime: "",
          endQueryTime: "",
          currentDateIndex: 0,
        },
        {
          startQueryTime: "",
          endQueryTime: "",
          currentDateIndex: 0,
        },
      ],
      filterTimesBoxShow: false,
      timeFilterArr: [
        {
          title: "全部",
          active: true,
          type: 0,
        },
        {
          title: "今天",
          active: false,
          type: 1,
        },
        {
          title: "昨天",
          active: false,
          type: 2,
        },
        {
          title: "最近三天",
          active: false,
          type: 3,
        },
        {
          title: "本周",
          active: false,
          type: 4,
        },
        {
          title: "上周",
          active: false,
          type: 5,
        },
        {
          title: "本月",
          active: false,
          type: 6,
        },
        {
          title: "上月",
          active: false,
          type: 7,
        },
      ],
      timeValueNew: "",
      startTimePopShow: false,
      endTimePopShow: false,
      filterTimesShow: false,
      FilterTimeArr: [
        {
          title: "全部",
          active: true,
          type: 0,
        },
        {
          title: "今天",
          active: false,
          type: 1,
        },
        {
          title: "昨天",
          active: false,
          type: 2,
        },
        {
          title: "最近三天",
          active: false,
          type: 3,
        },
        {
          title: "本周",
          active: false,
          type: 4,
        },
        {
          title: "上周",
          active: false,
          type: 5,
        },
        {
          title: "本月",
          active: false,
          type: 6,
        },
        {
          title: "上月",
          active: false,
          type: 7,
        },
      ],
      sTime: "",
      eTime: "",

      timeBoxShow1: false,
      timeBoxShow2: false,

      startTime: "",
      endTime: "",
      timeValue: "自定义日期",
      startQueryTime: "",
      endQueryTime: "",
      minDateMultiple: "",
      defaultDateMultiple: [`${year}-${month}-${date - 1}`],
      startTimeShow: false,
      endTimeShow: false,
      signInfo: [],
      actInfo: {},
      isInitialized: false,
      loading: false,
      actName: "",
      // 分析数据
      analysisData: [],
      imageUrl2: this.imageUrl,
      seeSignatureImgShow: false,
      signatureImgSrc: "",
      innerAudioContext: "",
      seeVideoShow: false,
      videoShow: false,
      videoUrl: "",
      nodataShow: false,
      dataDrawerShow: false,
      direction: "rtl",
      // 选项分析抽屉
      optionAnalysisDrawerShow: false,
      optionAnalysisList: [],
      optionAnalysisQuestion: "",
      tableData: [],
      routeParameter: {},
      photoList: [],
      photoShow: false,
      activityId: "",
      activityKey: "",
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      dialogUserName: "",
    };
  },
  created() {},
  mounted() {
    // 页面参数
    this.routeParameter = this.$route.query;
    console.log("页面路由参数", this.routeParameter);

    if (this.routeParameter.activityId) {
      this.activityId = this.routeParameter.activityId;
      console.log("设置 activityId", this.activityId);
    }
    if (this.routeParameter.alias) {
      this.activityKey = this.routeParameter.alias;
      console.log("设置 activityKey", this.activityKey);
    }

    if (!this.activityKey) {
      console.error("缺少 activityKey 参数");
      return;
    }

    this._activityDetail();
  },
  methods: {
    // 通用JSON解析工具方法
    safeJsonParse(data, defaultValue = null) {
      try {
        // 检查数据是否已经是对象，避免重复解析
        if (typeof data === "string") {
          return JSON.parse(data);
        } else if (typeof data === "object" && data !== null) {
          // 已经是对象，直接返回
          return data;
        } else {
          // 格式异常，返回默认值
          // console.warn("数据格式异常，使用默认值:", data);
          return defaultValue;
        }
      } catch (e) {
        // console.error("JSON解析错误:", e, "原始数据:", data);
        // 解析失败时返回默认值，避免后续错误
        return defaultValue;
      }
    },
    proceData(arr, fieldList = []) {
      return arr.map((item) => {
        // 创建副本避免污染原始对象
        const processedItem = { ...item };

        // 从 fieldList 中获取对应字段的配置
        const fieldConfig = fieldList.find((field) => field.id === item.id);
        if (fieldConfig) {
          processedItem.encryption = fieldConfig.encryption;
          processedItem.isOpen = fieldConfig.isOpen;
          processedItem.isRequired = fieldConfig.isRequired;
          processedItem.fieldName = fieldConfig.fieldName;
        }

        return processedItem;
      });
    },
    async lookUserDetail(row, index) {
      const filterUserName = this.theadList.filter((item) => item.type == 1)[0];
      if (filterUserName) {
        this.dialogUserName = row[filterUserName.key];
      }
      // this.selectedItem = row;
      // this.userDetailShow = true;
      // console.log(row);
      // const res = await activityDetail({
      //   activityId: this.activityId,
      //   selectType: "see",
      // });
      for (const item of this.rawData[index]) {
        if (item.activityId) {
          console.log(item);

          const result = await getSignListMore({
            pageNum: 1,
            pageSize: 10,
            activityId: item.activityId,
            fmSignListId: "",
            name: "",
            signInfoStatus: "",
            startQueryTime: this.startQueryTime || "",
            endQueryTime: this.endQueryTime || "",
            listGroupName: "",
            id: item.orderId,
          });
          console.log(result.data.pageInfo.list);
          const curPageData = result.data.pageInfo.list;
          this.userDetailList = curPageData;
          // 处理每个报名项的字段数据
          this.userDetailList.forEach((item, index) => {
            const cloneSignInfo = this.safeJsonParse(item.sign_info, []);
            // 使用最新的 fieldList 处理数据
            item.sign_info = this.proceData(
              cloneSignInfo,
              result.data.fieldList,
            );
          });
          this.userDetailShow = true;
          this.loadUserDetailListVideo();
        }
      }

      // this.selectedItem = res.data.activityDetail;
    },
    async loadUserDetailListVideo() {
      this.userDetailList.forEach(async (item) => {
        if (item.sign_info) {
          item.sign_info.forEach(async (fieldItem) => {
            if (fieldItem.type == 6) {
              const result = await this.getVideoUrl(
                fieldItem.value,
                fieldItem.vid,
              );
              // 使用 $set 确保触发响应式更新
              if (result) {
                this.$set(fieldItem, "videoUrl", result);
                console.log(fieldItem.videoUrl, "fieldItem.videoUrl");
              }
            }
          });
        }
      });
    },
    // 获取表头样式类（固定第一列、第二列和最后一列）
    getThClass(item, idx) {
      const totalCols = this.theadList.length;
      return {
        "sticky-col-first": idx === 0, // 第一列（序号）
        "sticky-col-second": idx === 1, // 第二列（第一个动态字段）
        "sticky-col-last": idx === totalCols - 1, // 最后一列（更多）
      };
    },
    // 获取表格单元格样式类（固定第二列）
    getTdClass(idx) {
      return {
        "sticky-col-second": idx === 0, // 动态字段的第一列（即表格的第二列）
      };
    },
    seeWhoSelected(option) {
      console.log("选项数据:", option);
      this.optionAnalysisQuestion =
        option.question.split("/")[0] + "[" + option.type + "]";
      this.openOptionDrawer(option);
    },
    // 打开选项分析抽屉
    async openOptionDrawer(option) {
      console.log("开始调用接口，参数:", {
        question: option.question,
        activityId: this.activityId,
      });

      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        fullscreen: true,
      });
      try {
        const res = await ListOfPersonnelOptions({
          question: option.question,
          activityId: this.activityId,
        });
        console.log("接口返回结果:", res);
        if (res.status === 1) {
          // 转为 { key, value }[] 避免 key 含点（如 4.5678）被解析为路径
          this.optionAnalysisList = res.data;
          this.optionAnalysisDrawerShow = true;
        } else {
          this.$message.error(res.msg || "加载失败");
        }
      } catch (error) {
        console.error("获取选项人员列表失败:", error);
        this.$message.error("加载失败：" + error.message);
      } finally {
        loading.close();
      }
    },
    // 关闭选项分析抽屉
    handleOptionDrawerClose(done) {
      this.optionAnalysisDrawerShow = false;
      this.optionAnalysisList = [];
      this.optionAnalysisQuestion = "";
    },
    // 复制名单
    async copyNames(nameItem) {
      if (!Array.isArray(nameItem)) return;
      // 提取姓名（最后一个/前面的部分）并用中文逗号连接
      const names = nameItem.map((item) => this.getName(item)).join(",");

      // 尝试使用现代 Clipboard API，失败则降级到 execCommand
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(names);
          this.$message.success("复制成功");
          return;
        } catch (err) {
          console.log("Clipboard API 失败，使用降级方案:", err);
        }
      }

      // 降级方案：使用 execCommand
      try {
        const textarea = document.createElement("textarea");
        textarea.value = names;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        const successful = document.execCommand("copy");
        document.body.removeChild(textarea);
        if (successful) {
          this.$message.success("复制成功");
        } else {
          this.$message.error("复制失败");
        }
      } catch (err) {
        console.error("execCommand 复制失败:", err);
        this.$message.error("复制失败，请手动复制");
      }
    },
    // 获取姓名（去掉路径前缀）
    getName(str) {
      if (typeof str !== "string") return "";
      const idx = str.lastIndexOf("/");
      return idx === -1 ? str : str.slice(0, idx);
    },
    // 数据统计 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
    closeSwiper() {
      this.photoList = [];
      this.photoShow = false;
    },
    openTimePop() {
      this.filterDateType = this.tabNum - 1;
      this.filterTimesBoxShow = true;
    },
    handleClick(row) {
      console.log(row);
    },
    toPageStatistics(row) {
      this.dataDrawerShow = true;
    },
    dataDrawerClose() {
      this.dataDrawerShow = false;
    },

    onPlay(val) {
      // const bgAudioManager = uni.getBackgroundAudioManager();
      // bgAudioManager.title = val.name;  // 音频标题，必填
      // bgAudioManager.epname = '音频播放';  // 专辑名
      // // bgAudioManager.singer = '未知';  // 歌手名
      // // bgAudioManager.coverImgUrl = 'https://example.com/default-cover.jpg'; // 封面图，可选
      // bgAudioManager.src = val.url;  // 音频链接，必填
      // bgAudioManager.audioType = 'audio';
      // // 监听播放结束
      // bgAudioManager.onEnded(() => {
      //
      // });
    },
    seeVideo(val, row) {
      const filterUserName = this.theadList.filter((item) => item.type == 1)[0];
      if (filterUserName) {
        this.dialogUserName = row[filterUserName.key];
      }

      this.videoUrl = this.imageUrl + val;
      this.videoShow = true;
      this.seeVideoShow = true;
    },
    // 查看大图
    seeBigImg(val, type, row) {
      // console.log(this.rawData, "row");

      if (!val) {
        return;
      }

      const filterUserName = this.theadList.filter((item) => item.type == 1)[0];
      if (filterUserName) {
        this.dialogUserName = row[filterUserName.key];
      }
      if (type == 1) {
        this.photoList = val.map((item) => {
          return this.imageUrl + item;
        });
        this.photoShow = true;
      }
    },
    seeSignFileImg(val, type, row) {
      if (!val) {
        return;
      }
      const filterUserName = this.theadList.filter((item) => item.type == 1)[0];
      if (filterUserName) {
        this.dialogUserName = row[filterUserName.key];
      }
      if (type == 1) {
        this.photoList = val.map((item) => {
          return item;
        });
        this.photoShow = true;
      }
    },
    seeSignature(val, row) {
      const filterUserName = this.theadList.filter((item) => item.type == 1)[0];
      if (filterUserName) {
        this.dialogUserName = row[filterUserName.key];
      }
      this.signatureImgSrc = this.imageUrl + val;
      this.seeSignatureImgShow = true;
      this.photoList = [this.signatureImgSrc];
      this.photoShow = true;
    },
    close(type) {
      if (type === "Signature") {
        this.seeSignatureImgShow = false;
      }
      if (type === "video") {
        this.seeVideoShow = false;
        this.videoShow = false;
      }
    },
    // 查看文件
    seeFile(fItem, fileIndex) {
      console.log(fItem, fileIndex, "文件哦");
    },
    changTab(num) {
      this.tabNum = num;
    },
    timeRangeConfirmFn1(e) {
      this.startQueryTime = e[0];
      this.startTimeShow = false;
    },

    timeRangeConfirmFn2(e) {
      this.endQueryTime = e[0];
      this.endTimeShow = false;
    },
    timeRangeConfirmFn3(e) {
      this.sTime = e[0];
      this.startTimePopShow = false;
    },

    timeRangeConfirmFn4(e) {
      this.eTime = e[0];
      this.endTimePopShow = false;
    },
    cancelFTSet() {
      this.filterTimesBoxShow = false;
      this.filterTimesShow = false;
    },
    // 统一管理弹窗关闭方法
    closePopup(type) {
      console.log(type);
      switch (type) {
        case "select":
          this.selectBoxShow = false;
          break;
        case "filterTimesNew":
          this.filterTimesShow = false;
          break;
        case "filterTimes":
          this.filterTimesBoxShow = false;
          break;
        case "timeRange":
          this.timeShow = false;
          break;
      }
    },
    // 视图
    async _tableAttempting() {
      console.log("开始获取表格数据", {
        activityKey: this.activityKey,
        startQueryTime: this.startQueryTime,
        endQueryTime: this.endQueryTime,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      });

      let result = await tableAttempting({
        activityKey: this.activityKey, //活动id
        startQueryTime: this.startQueryTime, //开始时间
        endQueryTime: this.endQueryTime, //结束时间
        pageNum: this.currentPage, //当前页
        pageSize: this.pageSize, //每页大小
      });

      console.log("API返回结果", result);

      if (result.status == 1) {
        this.isInitialized = false;
        const loading = this.$loading({
          lock: true,
          text: "加载中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        // 处理API返回的数据结构：result.data.list 是实际的数据数组
        let dataArray = [];
        if (
          result.data &&
          result.data.list &&
          Array.isArray(result.data.list)
        ) {
          dataArray = result.data.list;
          // 设置总数量
          this.totalCount =
            result.data.total || result.data.count || dataArray.length;
        } else if (Array.isArray(result.data)) {
          dataArray = result.data;
          this.totalCount = dataArray.length;
        }
        this.rawData = dataArray;
        console.log(
          "设置 rawData",
          this.rawData,
          "totalCount",
          this.totalCount,
        );

        this.$nextTick(() => {
          this.filterTimesBoxShow = false;
          this.processData();
          setTimeout(() => {
            loading.close();
            // 不再重复设置 isInitialized 和 nodataShow，因为 processData 已经处理了
          }, 800);
        });
      } else {
        console.log("API调用失败", result);
        // 如果API调用失败，确保 rawData 是空数组
        this.rawData = [];
        this.theadList = [];
        this.tbodyList = [];
        this.totalCount = 0;
        this.nodataShow = true;
        this.isInitialized = true;
      }
    },
    async _listAnalysisExport() {
      let result = await listAnalysisExport({
        activityId: this.activityId,
        startQueryTime: this.sTime, //开始时间
        endQueryTime: this.eTime, //结束时间
      });

      if (result.status == 1) {
        this.loading.close();
        if (result.msg === "-1") {
          this.$message("暂无数据，请重新筛选");
          return false;
        }
        this.filterTimesShow = false;
        // 编码
        var downloadUrl = "";
        downloadUrl = encodeURIComponent(result.msg);
        var actName = "";
        actName = encodeURIComponent(this.actName);
        let routeData = this.$router.resolve({
          path:
            "/exportSuccessPage?downloadUrl=" +
            downloadUrl +
            "&actName=" +
            actName,
        });
        window.open(routeData.href, "_blank");
      } else {
        this.loading.close();
        this.$message("result.msg");
      }
    },
    seeData(val, index) {
      console.log(val, index, "今天星期四啦");
    },
    async onViewMore(row) {
      // 查看更多：可在此处跳转详情或打开弹窗，row 为当前行数据，index 为行序号
      // console.log(this.rawData[index]);
      const id =
        typeof row === "string" && row.includes("/")
          ? row.split("/").pop()
          : row;
      console.log(id);
      this.dialogUserName = row.replaceAll("/" + id, "");

      const result = await getSignListMore({
        pageNum: 1,
        pageSize: 10,
        activityId: this.activityId,
        id,
      });
      this.viewMoreShow = true;
      console.log(result);
      if (result.status == 1) {
        const curPageData = result.data.pageInfo.list;
        this.viewMoreList = curPageData;
        // 处理每个报名项的字段数据
        this.viewMoreList.forEach((item, index) => {
          const cloneSignInfo = this.safeJsonParse(item.sign_info, []);
          // 使用最新的 fieldList 处理数据
          item.sign_info = this.proceData(cloneSignInfo, result.data.fieldList);
        });
        this.viewMoreList.map((itm) => {
          itm.sign_info.map((item, index) => {
            item.isPlay = true;
            if (item.type == 12) {
              this.covers.push({
                id: 9005,
                latitude: item.value.latitude,
                longitude: item.value.longitude,
                iconPath: "/static/img/dingwei.png",
                bgColor: "",
                width: "45rpx",
                height: "60rpx",
              });
            }
            if (item.type == "31") {
              if (item.value == undefined) {
                item["value"] = "";
                item.startTime = "";
                item.endTime = "";
              } else if (!item.value.includes("undefined")) {
                var arr = item.value.split("~");
                if (arr.length > 0) {
                  item.startTime = arr[0];
                  item.endTime = arr[1];
                } else {
                  item.startTime = "";
                  item.endTime = "";
                }
              } else if (item.value.includes("undefined")) {
                item["value"] = "";
                item.startTime = "";
                item.endTime = "";
              }
            }
          });
        });
      }
      // 处理评论列表
      this.viewMoreList.forEach((item) => {
        const id = item.id;

        // 如果该项有评论列表，处理评论数据
        if (item.commentList && item.commentList.length > 0) {
          // 为每条评论添加 orderId
          const commentsWithOrderId = item.commentList.map((comment) => ({
            ...comment,
            orderId: id,
          }));

          // 合并到总评论列表
          const existingComments = this.pllist.filter((c) => c.orderId !== id);
          this.pllist = [...existingComments, ...commentsWithOrderId];

          // 初始化该项的评论状态
          this.commentStates = {
            ...this.commentStates,
            [id]: {
              pageNum: 2,
              isLastPage: item.commentList.length < 2,
              totalRow: item.commentList.length,
              showCount: 2,
            },
          };
        } else {
          // 没有评论时也要初始化状态
          this.commentStates = {
            ...this.commentStates,
            [id]: {
              pageNum: 1,
              isLastPage: true,
              totalRow: 0,
              showCount: 2,
            },
          };
        }
      });

      // for (const item of this.rawData[index]) {
      //   if (item.activityId) {
      //     // 后续功能开发：跳转详情页
      //     // this.$router.push({
      //     //     path: '/pages-views/partInfo/partInfo',
      //     //     query: {
      //     //         activityId: item.activityId,
      //     //         id: item.orderId,
      //     //         showActions: '0'
      //     //     }
      //     // });
      //     // console.log("查看详情:", {
      //     //   activityId: item.activityId,
      //     //   orderId: item.orderId,
      //     // });
      //   }
      // }
    },
    processData() {
      this.isInitialized = true;
      // 生成表头（不包含报名 id、微信名称）
      const headers = new Map();

      // 处理表头
      this.rawData.forEach((row) => {
        row.forEach((field) => {
          if (
            field.fieldName === "微信名称" ||
            field.fieldName === "报名 id" ||
            field.fieldName === "报名列表 id" ||
            field.type == 33
          )
            return;
          const key = field.id || "999";
          if (!headers.has(key)) {
            headers.set(key, {
              title: field.fieldName,
              key: key,
              type: field.type,
            });
          }
        });
      });

      // 转换为数组并排序（仅序号 + 其他字段，不含报名 id、微信名称）+ 更多列
      this.theadList = [
        { title: "序号", key: "index" },
        ...Array.from(headers.values()),
        { title: "更多", key: "more" },
      ];

      // 处理表格数据（不包含报名 id、微信名称）
      this.tbodyList = this.rawData.map((row) => {
        const item = {};
        row.forEach((field) => {
          if (
            field.fieldName === "微信名称" ||
            field.fieldName === "报名 id" ||
            field.type == 33
          ) {
            return;
          }

          const key = field.id || "999";
          let value = field.value;

          // 处理多选类型
          if ([2, 4].includes(Number(field.type)) && Array.isArray(value)) {
            value = value.join(",");
          }

          item[key] = value;
        });
        return item;
      });
      console.log(this.tbodyList, "tbodyList");
      console.log(this.theadList, "theadList");

      this.$nextTick(() => {
        if (this.tbodyList.length) {
          this.nodataShow = false;
        } else {
          this.nodataShow = true;
        }
        // 异步加载视频 URL，不阻塞列表渲染
        this.loadVideoUrls();
      });
    },
    async getVideoUrl(value, vid) {
      try {
        const result = await getNewVideoPathUrl({
          vid: vid,
          address: value,
        });
        if (result.status === 1 && result.msg) {
          return result.msg;
        } else {
          console.error("获取视频地址失败:", result);
          return "";
        }
      } catch (error) {
        console.error("获取视频地址异常:", error);
        return "";
      }
    },
    // 异步加载视频 URL（不阻塞列表渲染）
    async loadVideoUrls() {
      if (!this.tbodyList.length) return;

      // 找出所有类型 6（视频）的列 key
      const videoKeys = this.theadList
        .filter((item) => item.type === "6" || item.type === 6)
        .map((item) => item.key);

      if (!videoKeys.length) return;

      // 遍历每一行，异步获取视频 URL 并强制触发更新
      this.tbodyList.forEach((row, rowIndex) => {
        videoKeys.forEach(async (key) => {
          const value = row[key];
          if (value && typeof value === "string" && value.includes("|")) {
            const vid = value.split("|")[1];
            const res = await this.getVideoUrl(value, vid);
            if (res) {
              // 使用 $set 确保触发响应式更新
              this.$set(this.tbodyList[rowIndex], key, res);
              console.log(`更新视频地址 row${rowIndex} key${key}:`, res);
            }
          }
        });
      });
    },
    // 处理数组值显示
    formatValue(value, type) {
      if (type === "999") {
        return {
          value: value,
          wx_profile_photo: value,
        };
      }
      return Array.isArray(value) ? value.join(", ") : value;
    },

    // 统计分析
    async _listAnalysis() {
      let result = await listAnalysis({
        activityId: this.activityId, //活动id
        startQueryTime: this.startQueryTime, //开始时间
        endQueryTime: this.endQueryTime, //结束时间
      });
      if (result.status == 1) {
        // 处理API返回的数据结构：result.data.list 是实际的数据数组
        let dataArray = [];
        if (
          result.data &&
          result.data.list &&
          Array.isArray(result.data.list)
        ) {
          dataArray = result.data.list;
        } else if (Array.isArray(result.data)) {
          dataArray = result.data;
        }
        this.analysisData = dataArray;
        // 为每个 item 添加 chartType 属性
        this.analysisData.forEach((item) => {
          item.chartType = 1;
        });
        if (this.analysisData.length) {
          this.nodataShow = false;
        } else {
          this.nodataShow = true;
        }
      } else {
        // 如果API调用失败，确保 analysisData 是空数组
        this.analysisData = [];
        this.nodataShow = true;
      }
      this.filterTimesBoxShow = false;
    },

    // 获取活动详情
    async _activityDetail() {
      console.log("开始获取活动详情", this.activityKey);
      var obj = {
        activityKey: this.activityKey,
        selectType: "see",
      };
      const { data, msg, status } = await activityDetail(obj);
      console.log("活动详情API返回", { data, msg, status });

      if (status == 1) {
        this.activityId = data.activityDetail.id;
        this.actName = data.activityDetail.name;
        this.actInfo = data.activityDetail;
        this.minDateMultiple = data.activityDetail.beginTime.substring(0, 10);
        console.log("设置活动信息", {
          activityId: this.activityId,
          actName: this.actName,
          activityKey: this.activityKey,
        });
        this._tableAttempting();
        this._listAnalysis();
      } else {
        console.log("获取活动详情失败", msg);
      }
    },

    currentSelect(item, idx) {
      console.log(item.type, "typene");
      this.filterDateArr[this.filterDateType].currentDateIndex = idx;
      this.timeFilterArr.forEach((v) => (v.active = false));
      item.active = true;

      const padZero = (n) => n.toString().padStart(2, "0");
      const format = (date) =>
        `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(
          date.getDate(),
        )}`;

      const today = new Date();
      let start, end;

      switch (item.type) {
        case 0: // 全部
          this.startTime = "";
          this.endTime = "";
          this.timeValue = "自定义日期";
          this.startQueryTime = "";
          this.endQueryTime = "";
          this.filterDateArr[this.filterDateType].startQueryTime =
            this.startQueryTime;
          this.filterDateArr[this.filterDateType].endQueryTime =
            this.endQueryTime;
          return;

        case 1: // 今天
          start = end = today;
          break;

        case 2: // 昨天
          var yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);
          start = end = yesterday;
          break;

        case 3: // 最近三天
          start = new Date(today);
          start.setDate(today.getDate() - 2);
          end = today;
          break;

        case 4: // 本周（周一到周日）
          start = new Date(today);
          // 计算到本周一的差值（当today.getDay()=1(周一)时，差0天）
          var dayDiff = (today.getDay() + 6) % 7;
          start.setDate(today.getDate() - dayDiff);
          end = new Date(start);
          end.setDate(start.getDate() + 6);
          break;

        case 5: // 上周（周一到周日）
          // 先找到本周一
          var thisMonday = new Date(today);
          thisMonday.setDate(today.getDate() - ((today.getDay() + 6) % 7));
          // 上周日是本周一减1天
          end = new Date(thisMonday);
          end.setDate(thisMonday.getDate() - 1);
          // 上周一是上周日减6天
          start = new Date(end);
          start.setDate(end.getDate() - 6);
          break;

        case 6: // 本月（1号到当月最后一天）
          start = new Date(today.getFullYear(), today.getMonth(), 1);
          end = new Date(today.getFullYear(), today.getMonth() + 1, 0); // 关键修改点
          break;

        case 7: // 上月
          start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          end = new Date(today.getFullYear(), today.getMonth(), 0);
          break;
      }

      this.startTime = format(start);
      this.endTime = format(end);

      this.startQueryTime = this.startTime;
      this.endQueryTime = this.endTime;

      this.filterDateArr[this.filterDateType].startQueryTime =
        this.startQueryTime;
      this.filterDateArr[this.filterDateType].endQueryTime = this.endQueryTime;

      this.timeValue = this.startQueryTime + " ~ " + this.endQueryTime;
    },
    currentSelectNew(item) {
      console.log(item.type, "typene");
      this.FilterTimeArr.forEach((v) => (v.active = false));
      item.active = true;

      const padZero = (n) => n.toString().padStart(2, "0");
      const format = (date) =>
        `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(
          date.getDate(),
        )}`;

      const today = new Date();
      let start, end;

      switch (item.type) {
        case 0: // 全部
          this.sTime = "";
          this.eTime = "";
          this.timeValueNew = "自定义日期";
          this.startQueryTime = "";
          this.endQueryTime = "";
          return;

        case 1: // 今天
          start = end = today;
          break;

        case 2: // 昨天
          var yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);
          start = end = yesterday;
          break;

        case 3: // 最近三天
          start = new Date(today);
          start.setDate(today.getDate() - 2);
          end = today;
          break;

        case 4: // 本周（周一到周日）
          start = new Date(today);
          // 计算到本周一的差值（当today.getDay()=1(周一)时，差0天）
          var dayDiff = (today.getDay() + 6) % 7;
          start.setDate(today.getDate() - dayDiff);
          end = new Date(start);
          end.setDate(start.getDate() + 6);
          break;

        case 5: // 上周（周一到周日）
          // 先找到本周一
          var thisMonday = new Date(today);
          thisMonday.setDate(today.getDate() - ((today.getDay() + 6) % 7));
          // 上周日是本周一减1天
          end = new Date(thisMonday);
          end.setDate(thisMonday.getDate() - 1);
          // 上周一是上周日减6天
          start = new Date(end);
          start.setDate(end.getDate() - 6);
          break;

        case 6: // 本月（1号到当月最后一天）
          start = new Date(today.getFullYear(), today.getMonth(), 1);
          end = new Date(today.getFullYear(), today.getMonth() + 1, 0); // 关键修改点
          break;

        case 7: // 上月
          start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          end = new Date(today.getFullYear(), today.getMonth(), 0);
          break;
      }

      this.sTime = format(start);
      this.eTime = format(end);

      this.timeValueNew = this.sTime + " ~ " + this.eTime;
    },
    toPageDaoChu() {
      if (this.nodataShow == true) {
        this.$message("暂无数据");
        return;
      }
      let routeData = this.$router.resolve({
        path: "/exportDataPage?alias=" + this.activityKey,
      });
      window.open(routeData.href, "_blank");
    },
    daoChuData() {
      if (this.nodataShow == true) {
        this.$message("暂无数据");
        return;
      }
      this.loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this._listAnalysisExport();
    },

    cancelStep() {
      this.filterTimesBoxShow = false;
      this.filterTimesShow = false;
    },
    clearTimeVal() {
      this.startQueryTime = "";
      this.endQueryTime = "";
      this.timeFilterArr.forEach((v) => (v.active = false));
      this.timeFilterArr[0].active = true;
      this.timeBoxShow1 = false;
      this.currentPage = 1; // 重置到第一页
      this._tableAttempting();
    },
    clearAnalysTimeVal() {
      this.sTime = "";
      this.eTime = "";
      this.FilterTimeArr.forEach((v) => (v.active = false));
      this.FilterTimeArr[0].active = true;
      this.timeBoxShow2 = false;
      this._listAnalysis();
    },
    submitFn() {
      // 验证时间字段
      this.startQueryTime =
        this.filterDateArr[this.filterDateType].startQueryTime;
      this.endQueryTime = this.filterDateArr[this.filterDateType].endQueryTime;
      console.log(this.startQueryTime, "this.startQueryTime");
      console.log(this.endQueryTime, "this.endQueryTime");
      if (this.startQueryTime || this.endQueryTime) {
        if (!this.startQueryTime || !this.endQueryTime) {
          this.$message("开始时间和结束时间必须同时填写");
          return;
        }

        // 将时间字符串转换为时间戳进行比较
        const startTime = new Date(this.startQueryTime).getTime();
        const endTime = new Date(this.endQueryTime).getTime();

        if (startTime > endTime) {
          this.$message("开始时间不能大于结束时间");
          return;
        }
      }
      if (this.tabNum == 1) {
        this.currentPage = 1; // 筛选时重置到第一页
        this._tableAttempting();
      } else {
        this._listAnalysis();
      }
    },
    consleDate(e) {
      console.log(e);
    },
    submitAnalysisFn() {
      // 验证时间字段
      if (this.sTime || this.eTime) {
        if (!this.sTime || !this.eTime) {
          // uni.showToast({
          //     title: '开始时间和结束时间必须同时填写',
          //     icon: 'none'
          // });
          return;
        }

        // 将时间字符串转换为时间戳进行比较
        const startTime = new Date(this.sTime).getTime();
        const endTime = new Date(this.eTime).getTime();

        if (startTime > endTime) {
          // uni.showToast({
          //     title: '开始时间不能大于结束时间',
          //     icon: 'none'
          // });
          return;
        }
      }
      this.timeBoxShow2 = true;
      this.filterTimesShow = false;
      this._listAnalysis();
    },
    closeTimeRange() {
      this.timeShow = false;
      this.startTimeShow = false;
      this.endTimeShow = false;
      this.startTimePopShow = false;
      this.endTimePopShow = false;
    },

    // 分页处理
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this._tableAttempting();
    },
    handlePageChange(currentPage) {
      this.currentPage = currentPage;
      this._tableAttempting();
    },

    // 数据统计 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
  },
};
</script>
<style lang="scss" scoped>
// 数据统计 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
.b-marT-10 {
  margin-top: 10px;
}
.user-detail-drawer {
  ::v-deep .el-drawer__header {
    margin-bottom: 0;
  }
}
.b-marT-20 {
  margin-top: 20px;
}
/* flex布局 */
.flex-depart-left {
  display: flex;
  align-items: center;
}
.flex-depart-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex-depart-center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex-depart-center-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.flex-depart-top {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.flex-depart-left-warp {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.flex-depart-center-top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.flex-depart-left-center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

/*大图排序*/
.flex-depart-column-top-left {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.drawBottomBtn {
  width: 100%;
  height: 70px;
  position: absolute;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
  padding-right: 20px;
}
.drawerOutBox {
  padding: 0 20px;
  height: 100%;
  position: relative;
}
.tabs-box {
  height: 45px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: transparent;
  border-radius: 4px;
  padding: 0;
  gap: 10px;
}
.tabs-item {
  position: relative;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  cursor: pointer;
  span {
    color: #1877ff;
    font-weight: normal;
    font-size: 14px;
    padding: 8px 20px;
    border-radius: 4px;
    transition: all 0.3s;
    border: 1px solid #1877ff;
    background-color: #fff;
    width: 100%;
    text-align: center;
    display: block;
    box-sizing: border-box;
  }
}
.act-tabs-style {
  color: #fff !important;
  background-color: #1877ff !important;
  font-weight: bold;
  border-color: #1877ff !important;
}
// ... 保持不变 ...
.scroll-view_H {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}
.table-box {
  padding: 0 10px 10px;
  background-color: white;
}
.table-box2 {
  margin-bottom: 10px;
}
.filter-time-box {
  padding: 10px 10px 10px;
  background-color: white;
  margin-top: 10px;
}
.f-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 120px;
  height: 33px;
  border: 1px solid #e9e9e9;
  border-radius: 17px;
  padding: 0 10px;
  image {
    width: 14px;
    height: 16px;
  }
  .txt {
    font-size: 14px;
  }
}
.time-box {
  height: 42px;
  background: #f7f7f7;
  border: 1px solid #dcdde0;
  border-radius: 4px;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 12.5px;
  text {
    font-size: 14px;
    color: #1877ff;
  }
}
.bottomBtn-box {
  width: 100%;
  height: 70px;
  padding-bottom: calc(-18.5px + env(safe-area-inset-bottom));
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 9999999;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding-left: 15px;
  padding-right: 15px;
  .btn {
    width: 100%;
    height: 50px;
    background: #1877ff;
    border-radius: 25px;
    font-size: 16px;
    font-weight: bold;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.reject-con {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  .close-xsxq {
    position: absolute;
    right: 10px;
    top: 15px;
    image {
      height: 20px;
      width: 20px;
    }
  }
  .top-title {
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #e7e7e7;

    text {
      font-size: 18px;
      font-weight: bold;
      color: #2b2f36;
    }
    .re-close {
      position: absolute;
      right: 10px;
      top: 14px;
    }
  }
}
.tishi-title {
  line-height: 50px;
  border-bottom: 1px solid #eee;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  color: #333;
  text {
    color: #4a73f8;
  }
}
.s-times-box {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 10px 5px;
}
.times-item {
  width: 80px;
  height: 30px;
  background: rgba(24, 119, 255, 0.05);
  border: 0.5px solid rgba(24, 119, 255, 0.2);
  color: #1877ff;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  margin: 5px 3px;
  font-size: 13px;
  cursor: pointer;
}
// ... 其余样式继续转换 ...
.sort-box {
  width: 94%;
  margin: 0 auto;
  padding: 15px 0px;
  border-top: 1px solid #eee;
}
.sort-title {
  font-size: 15px;
  color: #555555;
  margin-bottom: 10px;
  font-weight: bold;
}
.nextBtn {
  width: 94%;
  margin: 0 auto;
  height: 50px;
  background: #1877ff;
  border-radius: 25px;
  color: white;
  font-size: 16px;
  text-align: center;
  line-height: 50px;
}
.t-box {
  width: 155px;
  height: 44px;
  background: #f7f7f7;
  border: 1px solid #dcdde0;
  border-radius: 4px;
  box-sizing: border-box;
  padding-left: 10px;
  font-size: 14px;
  color: #7e7e81;
}
// ... 继续保持相同的转换规则 ...
.wx-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
// ... 其他样式继续转换 ...
.nodata-box {
  height: 375px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 87px;
    height: 96px;
    margin-bottom: 10px;
  }
  span {
    font-size: 15px;
    color: #a7adc6;
  }
}
.drawer-nav-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  span {
    font-size: 18px;
    color: black;
    font-weight: bold;
  }
  i {
    cursor: pointer;
    font-size: 18px;
  }
}
.btns-box {
  padding-right: 10px;
}
.custom-btn,
.custom-btn-primary {
  border-radius: 18px !important;
  padding: 8px 16px;
  font-size: 14px;
}
.custom-btn {
  background-color: #fff;
  border-color: #1877ff;
  color: #1877ff;
}
.custom-btn-primary {
  background-color: #1877ff;
  border-color: #1877ff;
  color: #fff;
}
.comm-btn {
  width: 128px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  cursor: pointer;
  border-radius: 23px;
  span {
    font-size: 14px;
  }
}
.btn1 {
  border: 1px solid #929292;
}
.btn2 {
  border: 1px solid #1877ff;
  background-color: #1877ff;
  span {
    color: white;
  }
}

.no-wrap {
  max-width: 200px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.colorBlue {
  color: #1877ff;
  cursor: pointer;
}
.table-width {
  /*width: calc(100% - 10px);*/
}
.times-item-active {
  background-color: #1877ff;
  color: #fff;
}

.tips {
  font-size: 18px;
  text-align: left;
  color: #767d98;
  padding: 10px 0 10px 20px;
}
.s-analysis {
  margin-top: -10px;
}

.analysis-item {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
}

.analysis-table {
  flex: 0 0 calc(50% - 10px);
  min-width: 400px;

  table {
    border: 1px solid #eee;
    border-collapse: collapse;

    th,
    td {
      border: 1px solid #eee;
    }
  }
}

.analysis-chart {
  flex: 1;
  min-width: 400px;
}

.t-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  padding: 10px 0;
  margin-bottom: 10px;
}
.s-analysis .table thead th {
  &:last-child {
    width: 10%;
    min-width: 100px;
  }
  &:nth-child(2) {
    min-width: 100px;
    width: 20%;
  }
  &:nth-child(3) {
    width: 20%;
    min-width: 100px;
  }
}
.position-relative a {
  height: 100%;
  width: 100%;
  display: inline-block;
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
}
.swiper-img {
  height: 500px;
  width: auto;
}

// 固定列样式
// 第一列固定（序号）- 左侧
.table-responsive .table thead th.sticky-col-first,
.table-responsive .table tbody td.sticky-col-first {
  position: sticky;
  left: 0;
  background-color: #fff;
  z-index: 12;
  border-right: 1px solid #eee;
  width: 50px !important;
  min-width: 50px !important;
  max-width: 50px !important;
}

// 第二列固定（第一个动态字段）- 左侧
.table-responsive .table thead th.sticky-col-second,
.table-responsive .table tbody td.sticky-col-second {
  position: sticky;
  left: 50px;
  background-color: #fff;
  z-index: 11;
  border-right: 1px solid #eee;
}

// 最后一列固定（更多）- 右侧
.table-responsive .table thead th.sticky-col-last,
.table-responsive .table tbody td.sticky-col-last {
  position: sticky;
  right: 0;
  background-color: #fff;
  z-index: 12;
  border-left: 1px solid #eee;
  text-align: center;
  min-width: 100px;
}

.more-btn {
  color: #1877ff;
  cursor: pointer;
  font-size: 14px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
  display: inline-block;
}

.more-btn:hover {
  background-color: #f0f7ff;
}

// 选项分析抽屉样式
.option-analysis-content {
  padding: 0 20px;
  overflow-y: auto;

  .analysis-question-title {
    font-weight: bold;
    font-size: 16px;
    color: #323b5a;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e7e7e7;
  }

  .analysis-option-item {
    border: 1px solid #e7e7e7;
    border-radius: 6px;
    margin-bottom: 12px;
    overflow: hidden;

    .analysis-option-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f2f2f2;
      padding: 12px 16px;

      &-left {
        font-size: 14px;
        font-weight: bold;
        color: #2b2f36;
      }

      &-right {
        font-size: 14px;
        color: #1877ff;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }
      }
    }

    .analysis-option-body {
      padding: 12px 16px;
      font-size: 14px;
      color: #2b2f36;
      line-height: 1.8;

      .analysis-option-name {
        color: #1877ff;
        cursor: pointer;

        // &:hover {
        //   text-decoration: underline;
        // }
      }
    }
  }
}

// 数据统计 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
</style>
